
export const RD1Address='0:5e68a5df9064bebc2f262b4f9ab8f39bac3f2e23b211be7125f49cf22b3fc425'
export const RD2Address='0:83f14b7b651fde36b401b79c89d424e2aa188ec54dfc3f842d0fc53fe3347ff4'
export const roundDuration=60*6
export const network: 'localnet' | 'mainnet' | 'testnet' = 'testnet' 
